module.exports = __webpack_public_path__ + "static/media/Payment-a.ca5631f0.jpg";